import { z } from "zod";
import { addressRequiredSchema } from "../address";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const contactSchema = z
	.object({
		name: z.string().nonempty(),
		workspaceId: ZodStringNullable,
		email: ZodStringNullable,
		phone: ZodStringNullable,
		contactTypeId: z.uuid(),
		relatedContactId: ZodStringNullable,
		vatId: ZodStringNullable,
		taxNumber: ZodStringNullable,
	})
	.and(addressRequiredSchema);

export type ContactFormSchema = z.infer<typeof contactSchema>;
